export default __webpack_public_path__ + "static/media/SG-LightBlue-0000.07227499.png";